import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { removeConditionOptionAction } from 'editor/src/store/design/slice';
import { ConditionAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import getConditionChildrenKey from '../reducer/getConditionChildrenKey';

import { removeElementFromReflowGroupsOperation } from './reflowGroupOperations';
import updateHiddenElementsOperation from './updateHiddenElementsOperation';

const removeConditionOptionOperation =
  (address: ConditionAddress, optionId: string) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    // Capture the option's linked element uuids before removal so they can be
    // dropped from any reflow row, keeping rows in sync with the condition.
    const conditionGroup = getState().design.designData?.spreads[address.spreadIndex]?.conditionGroup;
    const removedUuids =
      conditionGroup?.children[getConditionChildrenKey(address.conditionId, optionId)]
        ?.filter((child) => child.type !== 'condition')
        .map((child) => child.id) ?? [];

    batch(() => {
      dispatch(removeConditionOptionAction({ address, optionId }));
      dispatch(updateHiddenElementsOperation());
      removedUuids.forEach((uuid) => dispatch(removeElementFromReflowGroupsOperation(address.spreadIndex, uuid)));
    });
  };

export default removeConditionOptionOperation;
